import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "el-form-w2"
};
const _hoisted_2 = {
  class: "el-form-w2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form_item = _resolveComponent("el-form-item");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form_item, null, {
    label: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("span", null, "宽", -1)]))]),
    default: _withCtx(() => [_createVNode(_component_el_input_number, {
      min: $data.minWidth,
      modelValue: $data.form.width,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.width = $event),
      "controls-position": "right",
      onChange: _cache[1] || (_cache[1] = $event => $options.inputChange($event, 'width'))
    }, null, 8, ["min", "modelValue"])]),
    _: 1
  }), _createVNode(_component_el_form_item, null, {
    label: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("span", null, "高", -1)]))]),
    default: _withCtx(() => [_createVNode(_component_el_input_number, {
      min: $data.minHeight,
      modelValue: $data.form.height,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.height = $event),
      "controls-position": "right",
      onChange: _cache[3] || (_cache[3] = $event => $options.inputChange($event, 'height'))
    }, null, 8, ["min", "modelValue"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, null, {
    label: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("span", null, "横", -1)]))]),
    default: _withCtx(() => [_createVNode(_component_el_input_number, {
      modelValue: $data.form.x,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.x = $event),
      "controls-position": "right",
      onChange: _cache[5] || (_cache[5] = $event => $options.inputChange($event, 'x'))
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_el_form_item, null, {
    label: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("span", null, "纵", -1)]))]),
    default: _withCtx(() => [_createVNode(_component_el_input_number, {
      modelValue: $data.form.y,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.y = $event),
      "controls-position": "right",
      onChange: _cache[7] || (_cache[7] = $event => $options.inputChange($event, 'y'))
    }, null, 8, ["modelValue"])]),
    _: 1
  })])]);
}